import React from "react";
import { HREF } from "../../db";
import { Link } from "react-router-dom";

function Patent() {
  return (
    <React.Fragment>
      <div className="local fl">
        <h3>Rewards</h3>
        <div className="dqwz fr">
          Current Position:
          <Link to={HREF.INDEX}>Home</Link>
          &gt;
          <Link to={HREF.PUBLICATION}>Rewards</Link>
          &gt;
          <Link to={HREF.PUBLICATION_PATENT}>Patent</Link>
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.PUBLICATION_PAPER}>Paper</Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_PATENT} className="ej-current">
              Patent
            </Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_AWARDED}>Awarded</Link>
          </li>
        </ul>
      </div>
      <div className="Publications fl">
        <div className="Publications-con fl">
          <div id="vsb_content_1946_u51">
            <div id="vsb_content">
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  <strong>Invention patent (authorized):</strong>
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Linan Zhu、Yinwei Bao、Xiangjie Kong、Minhao Xu、Tuochao Zhu </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp; A quadruple extraction method of attribute sentiment based on grid labeling scheme，
                  <strong>Patent No</strong>：CN116451679A
                  <strong>Authorization announcement date</strong>:July 18,2023
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong, Linyan Wen, Feng Xia, Chenwei Zhang,
                    Xiaozhong Liu
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A scholar-recommendation and cooperative prediction method based on representational learning and competition theory
                  <strong> Patent No</strong>:201810853249.5 
                  <strong> Authorization announcement date</strong>:October 27, 2020
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong, Feng Xia, Zhenhuan Fu, Haochen Guo, Jinzhong Wang,
                    Xiaozhong Liu
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A method of metro station function mining based on LDA model
                  <strong> Patent No</strong>:201710817833.0 
                  <strong> Authorization announcement date</strong>:July 14, 2020
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong, Menglin Li, Feng Xia, Gaoxing Zhao,
                    Chengcheng Liu
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A visual analysis method of travel
                  co-occurrence phenomenon based on multi-source city data
                  <strong> Patent No</strong>:201710820085.1
                  <strong> Authorization announcement date</strong>:May 7, 2020
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong, Kaiqi Tian, Menglin Li, Xiaoteng Liu, Liangtian Wan,Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A route planning method of metro feeder bus based on route candidate set
                  <strong> Patent No</strong>:201711234971.2
                  <strong> Authorization announcement date</strong>:April 7, 2020
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong, Menglin Li, Zhenhuan Fu, Chaofan Zheng, Huang
                    Hui, Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A passenger flow prediction method for
                  shared bus stations based on multi-dimensional characteristics
                  of passenger travel 
                  <strong> Patent No</strong>:201711233503.3
                  <strong> Authorization announcement date</strong>:August 9,
                  2019
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Feng Xia, Xiaomei Bai, Zhaolong Ning, haozhen Liu, Xiangjie
                    Kong
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Journal Impact Evaluation Method
                  Based on Academic Big Data 
                  <strong> Patent No</strong>
                  :201610874338.9
                  <strong> Authorization announcement date</strong>:July 6, 2018
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Menglin Li、Zhuo Yang、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A visual analysis method for
                  co-occurrence of traffic trips based on taxi trajectory data
                  <strong> Patent No</strong>:201611137603.1
                  <strong> Authorization announcement date</strong>:July 6, 2018
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Feng Xia、Zhiqiang Gao、Huang Hui、Lian Lian
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A private car travel data set
                  generation method based on floating car data
                  <strong> Patent No</strong>: 201510508865.3
                  <strong> Authorization announcement date</strong>:April 10,
                  2018
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Feng Xia、Jinzhong Wang、Zhenhuan Fu、Lilin Li
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;Method for mining subway station functions based on doc2vec
                  <strong> Patent No</strong>: 201710822006.0
                  <strong> Authorization announcement date</strong>:Feberary 16,
                  2018
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Qianmeng Song、Zhuo Yang、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An urban traffic jam detection method
                  based on local abnormal factors 
                  <strong> Patent No</strong>
                  :201610125269.1
                  <strong> Authorization announcement date</strong>:November 10,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                  Xiangjie Kong、Linlin Guo、Jinzhong Wang、Meng Wang、Yuze Liu、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Multi-feature Metro Passenger Number Forecasting Method Based on Loyal Passengers 
                  <strong> Patent No</strong>
                  :201710273014.4
                  <strong> Authorization announcement date</strong>:August 18,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Zhenzhen Xu、Jun Zhang、 Xintong Liu、 Jinmeng Zhou、 Zhaolong Yao、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An Evaluation Method of Scholars' Influence Based on Academic Heterogeneous Network 
                  <strong> Patent No</strong>
                  :201611242445.6
                  <strong> Authorization announcement date</strong>:May 31,
                  2017
                </span>
              </p>
              
              
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Bin Feng、Han Yao、Xiangjie Kong</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Method for Solving the Sparse
                  Connectivity Problem of VANET Based on Traffic Density
                  <strong> Patent No</strong>:201510274296.0
                  <strong> Authorization announcement date</strong>:March 22,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Feng Xia、Yanan Niu、Xiangjie Kong</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A method of personalized
                  recommendation of teaching resources based on neural network
                  <strong> Patent No</strong>:201310217037.5
                  <strong> Authorization announcement date</strong>:March 1,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Zhenzhen Xu、Xinshuang Wang、Zhuo Yang、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A visualization method for station clustering based on subway data 
                  <strong> Patent No</strong>
                  :201610638506.4
                  <strong> Authorization announcement date</strong>:January 4,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Zhenzhen Xu、Feng Xia、Xiangjie Kong、Xiujuan Xu、Zongwei
                    Yang
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Visual Modeling Method of AUV Design
                  Process Based on Flex Technology 
                  <strong> Patent No</strong>
                  :201410206634.2
                  <strong> Authorization announcement date</strong>:January 18,
                  2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Xiangjie Kong、Xuannian Yu、Feng Xia、Zhaolong Yu、Qiuyuan Yang、Guoxu Lu</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A data-driven method for dividing and mining public transportation-oriented urban areas 
                  <strong> Patent No</strong>
                  :201610494378.0
                  <strong> Authorization announcement date</strong>:December 7,
                  2016
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Xiangjie Kong、Xiumiao Song、Feng Xia</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A method for calculating text
                  similarity based on target text 
                  <strong> Patent No</strong>
                  :201310105450.2
                  <strong> Authorization announcement date</strong>:December 23,
                  2015
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Feng Xia、Rui Chen、Xiangjie Kong</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An OpenXML-based docx document
                  creation and modification method 
                  <strong> Patent No</strong>
                  :201310280580.X
                  <strong> Authorization announcement date</strong>:November 11,
                  2015
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Hongfeng Xu、Weili Tan、Feng Xia、Hongmei Zhou、Lian
                    Lian、Xiangjie Kong、Chunfei Ma、Xiancai Geng、Long
                    He、Hongjie Zou
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;Transition method for active
                  phase-oriented arterial road coordination signal control
                  scheme 
                  <strong> Patent No</strong>: 201210375667.0
                  <strong> Authorization announcement date</strong>:December 14,
                  2014
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Yisheng Xie、Guojiang Shen、Xiangjie Kong、Yingyan Xu
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;Vehicle-mounted radar ranging and
                  speed measuring instrument 
                  <strong> Patent No</strong>
                  :200910100672.9
                  <strong> Authorization announcement date</strong>:November 30,
                  2011
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Guojiang Shen、Xiangjie Kong</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An intelligent coordinated control
                  method for urban road network traffic flow with bus priority
                  <strong> Patent No</strong>:200910100396.6
                  <strong> Authorization announcement date</strong>:January 19,
                  2011
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • <strong>Guojiang Shen、Xiangjie Kong</strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An Intelligent Combined Forecasting
                  Method for Short-term Traffic Flow 
                  <strong> Patent No</strong>
                  :200910100395.1
                  <strong> Authorization announcement date</strong>:September
                  29, 2010
                </span>
              </p>
              {/* <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  <strong>Invention patent (under acceptance):</strong>
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Linlin Guo、Jinzhong Wang、Meng Wang、Xuze
                    Liu、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Multi-feature Metro Passenger Number
                  Forecasting Method Based on Loyal Passengers
                  <strong>Patent No</strong>:201710273014.4
                  <strong>Application date</strong>:April 26, 2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Kaiqi Tian、Menglin Li、Xiaoteng
                    Liu、Liangtian Wan、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;Route planning method of subway feeder
                  bus based on route candidate set <strong>Patent No</strong>
                  :201711234971.2
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Feng Xia、Jinzhong Wang、Zhenhuan Fu、Yulin
                    Li
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A doc2vec-based method for mining
                  subway station functions <strong>Patent No</strong>
                  :201710822006.0
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Feng Xia、Zhenhuan Fu、Haochen Guo、Jinzhong
                    Wang
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A Method of Mining Metro Station
                  Function Based on LDA Model <strong>Patent No</strong>
                  :201710817833.0
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Jun Zhang、Xintong Jin、Jinmeng
                    Zhou、Zhaolong Ning、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;An Evaluation Method of Scholars'
                  Influence Based on Academic Heterogeneous Network
                  <strong>Patent No</strong>:201611242445.6
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Xuannian Xu、Feng Xia、Zhaolong Ning、Qiuyuan
                    Yang、Guoxu Lu
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A data-driven method for dividing and
                  mining public transportation-oriented urban regions
                  <strong>Patent No</strong>:201610494378.0
                  <strong>Application date</strong>:June 29, 2016
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  •
                  <strong>
                    Xiangjie Kong、Xinshuang Wang、Zhuo Yang、Feng Xia
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;A visualization method for station
                  clustering based on subway data <strong>Patent No</strong>
                  :201610638506.4 <strong>Application date</strong>:August 8,
                  2016
                </span>
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export { Patent };
